// 1. 외부 패키지
import { useRecoilValue } from "recoil"


// 2. 프로젝트 내부 alias


// 3. 상대 경로
import get_basic_detail_selector from "../../selector/get-basic-detail-selector";
import { getQuery, getEstateClassName } from "../../shared/function";


// 4. 타입


const LeftCategoryIcon = () => {

    const data = useRecoilValue(get_basic_detail_selector(getQuery().idx));

    const { type_text } = data.detail;

    return (
        <div className={getEstateClassName(type_text)}>{type_text}</div>
    );
};

export default LeftCategoryIcon;